import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { SupplementalInsuranceInfo } from '../SupplementalInsurance.constants';

const configFields = {
  impoundTypeId: {
    fieldId: 'impoundTypeId',
    type: FieldType.SELECT,
    nameInModel: `impoundTypeId`,
    inputProps: {
      options: [],
      placeholder: 'Type',
      label: 'Type',
      required: true,
      variant: 'outlined',
    },
  },
  monthlyAmount: {
    fieldId: 'monthlyAmount',
    type: FieldType.INPUT,
    nameInModel: `monthlyAmount`,
    inputProps: {
      label: 'Monthly Amount',
      placeholder: 'Monthly Amount',
      variant: 'outlined',
      type: FieldInputType.CURRENCY,
      minValue: 0,
      required: true,
    },
  },
};

export const getSupplementalInsurancesConfig = compose(
  fillConfigFieldsWithKeys,
  ({ supplementalInsuranceTypeOptions = [] }) => {
    return {
      groups: [
        {
          type: FieldType.GROUP,
          fields: [
            {
              ...configFields.impoundTypeId,
              inputProps: {
                ...configFields.impoundTypeId.inputProps,
                options: supplementalInsuranceTypeOptions,
              },
            },
            configFields.monthlyAmount,
          ],
          key: SupplementalInsuranceInfo.KEY,
        },
      ],
    };
  },
);
